/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdailyhint2Inputs */

const en_dropdailyhint2 = /** @type {(inputs: Dropdailyhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify hides each day’s wins at random times between 8 am and 10 pm. The first try after one wins. Everyone gets one try every 24 hours and can win once.`)
};

const de_dropdailyhint2 = /** @type {(inputs: Dropdailyhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify versteckt die Gewinne eines Tages zu zufälligen Zeiten zwischen 8 und 22 Uhr. Der erste Versuch danach gewinnt. Jede Person hat alle 24 Stunden einen Versuch und kann einmal gewinnen.`)
};

/**
* | output |
* | --- |
* | "Pulsify hides each day’s wins at random times between 8 am and 10 pm. The first try after one wins. Everyone gets one try every 24 hours and can win once." |
*
* @param {Dropdailyhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdailyhint2 = /** @type {((inputs?: Dropdailyhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdailyhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdailyhint2(inputs)
	return de_dropdailyhint2(inputs)
});
export { dropdailyhint2 as "dropDailyHint" }